<template>
    <commonIframe
    @page="newPage"
    @removePage="closeAndNew"></commonIframe>
</template>

<script>
// 招投标的管理
import commonIframe from './components/commonIframe.vue'
export default {
    data(){
        return {
            dynaHeight: document.documentElement.clientHeight - 105,
            token:document.cookie.split(';').filter(item=>item.indexOf('_TOKEN_KEY_')>-1)[0].replace('_TOKEN_KEY_=','').trim(),
            mcustom: undefined,
        }
    },
    components: {
        commonIframe
    },
    methods: {
        // 打开新页面
        newPage(edata) {
            window.sessionStorage.setItem(`/manage/${edata.code}`,JSON.stringify({
                path:"/openPage/index.html#/"+edata.code,
                data:edata.data,
                code:edata.code,
                title:edata.title
            }));
            this.$router.push(`/manage/${edata.code}`);
        },
        // 关闭当前页，再打开新页面
        closeAndNew(edata) {
            this.$emit('removePage',`/manage/${edata.code}`);
            if(edata.parentCode) {
                this.$emit('removePage',`/manage/${edata.parentCode}`);
                this.$router.push(`/manage/${edata.parentCode}`);
            }
        },
    },
}
</script>

<style lang="less" scoped></style>